import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    holidayPropertiesType,
    holidayYearsType,
} from '../../types';
import HolidayRow from './HolidayRow';

HolidaysList.propTypes = {
    holidayYears: holidayYearsType.isRequired,
    holidayProps: holidayPropertiesType.isRequired,
};

function HolidaysList(props) {
    const {
        holidayYears,
        holidayProps,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="holidays-list">
            <div className="rich-list-row rich-list-header holidays-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="holidays-header--values--year">{t('holidays.list-header.year')}</div>
                <div className="holidays-header--values--dates">{t('holidays.list-header.dates')}</div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                holidayYears.length
                    ? holidayYears.map((holidayYear) => (
                        <HolidayRow
                            holidayYear={holidayYear}
                            holidayProps={holidayProps}
                            key={holidayYear.year}
                        />
                    ))
                    : (
                        <div className="holidays-no-items">
                            {t('holidays.no-items')}
                        </div>
                    )
            }
        </div>
    );
}

export default HolidaysList;
